import { grpc } from "@improbable-eng/grpc-web";
import { UnaryOutput } from "@improbable-eng/grpc-web/dist/typings/unary";
import { ProtobufMessage } from "@improbable-eng/grpc-web/dist/typings/message";

import AuthUtils from "@/utils/auth-utils";

import { MerchantAdminService as Service } from "@/proto/pay/admin/all_pb_service";
import * as ServiceProto from "@/proto/pay/admin/all_pb";
import { MerchantListItem } from "@/types";

export default class PayService {
  constructor(private baseURL: string, private token: string) {}

  public async getMerchants(data: {
    sort?: ServiceProto.OrderMap[keyof ServiceProto.OrderMap];
    keyword?: string;
    page?: number;
    limit?: number;
  }): Promise<MerchantListItem[]> {
    const request = new ServiceProto.MerchantListRequest();

    if (data.sort) {
      request.setOrder(data.sort);
    }

    if (data.keyword) {
      request.setIdentifier(data.keyword);
    }

    if (data.page) {
      request.setPage(data.page);
    }

    if (data.limit) {
      request.setPagesize(data.limit);
    }

    const { status, message, statusMessage }: UnaryOutput<ProtobufMessage> =
      await new Promise((resolve) => {
        grpc.unary(Service.MerchantList, {
          request,
          host: this.baseURL,
          onEnd: resolve,
          metadata: AuthUtils.getMetadata(this.token),
        });
      });

    if (status !== grpc.Code.OK) {
      throw new Error(
        `Error with GetMerchants: code=${status} msg=${statusMessage}`
      );
    }
    const decoded = message as ServiceProto.MerchantListResponse;

    return decoded.getMerchantsList().map<MerchantListItem>((item) => ({
      id: item.getMerchantid(),
      name: item.getName(),
      email: item.getEmail(),
      subscription: item.getPlan(),
      isActive: item.getStatus().toLowerCase() === "active",
      isProcessing: false,
    }));
  }

  public async setMerchantStatus(
    data: ServiceProto.UpdateMerchantRequest.AsObject
  ) {
    const request = new ServiceProto.UpdateMerchantRequest();

    request.setMerchantid(data.merchantid);
    request.setStatus(data.status);

    const { status, message, statusMessage }: UnaryOutput<ProtobufMessage> =
      await new Promise((resolve) => {
        grpc.unary(Service.UpdateMerchant, {
          request,
          host: this.baseURL,
          onEnd: resolve,
          metadata: AuthUtils.getMetadata(this.token),
        });
      });

    if (status !== grpc.Code.OK) {
      throw new Error(
        `Error with GetClients: code=${status} msg=${statusMessage}`
      );
    }

    if (message === null) {
      throw new Error("received no data");
    }

    return "success";
  }
}
